import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Dot: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[3px] h-[4px]', className)}
    viewBox="0 0 3 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.8" cx="1.5" cy="2" r="1.5" fill="currentColor" />
  </svg>
);

export default Dot;
